import { visit } from "unist-util-visit";

export function addClassNameToPre() {
  return tree => {
    visit(tree, "element", node => {
      if (node.tagName === "pre") {
        node.properties = node.properties || {};
        node.properties.className = (node.properties.className || []).concat("code-pre");
      }
    });
  };
}

export const remarkVimeo = () => {
  return tree => {
    visit(tree, "paragraph", (node, index, parent) => {
      if (!parent || !index) return;

      const textNode = node.children[0];
      if (!textNode || textNode.type !== "text") return;

      const match = textNode.value.match(/^!vimeo\[(\d+)]$/);
      if (match) {
        const videoId = match[1];

        parent.children[index] = {
          type: "html",
          value: `
            <div style="position: relative; width: 100%; padding-bottom: 56.25%; height: 0; overflow: hidden;">
              <iframe 
                src="https://player.vimeo.com/video/${videoId}" 
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" 
                frameborder="0" 
                allow="autoplay; fullscreen; picture-in-picture" 
                allowfullscreen>
              </iframe>
            </div>
          `.trim(),
        };
      }
    });
  };
};
